import { StorageKeys } from 'common/storage/constants';
import { useLocalStorage } from 'src/shared/storage/Storage';
import { match } from 'ts-pattern';

export type LandingMarketSegment =
  | 'dietary-restrictions'
  | 'kid-friendly'
  | 'authentic-cuisine'
  | 'indian-community'
  | 'chinese-community'
  | 'halal-community'
  | 'indian-meal-plan'
  | 'yaf-dink'
  | 'control'
  | 'yaf-ff'
  | 'yaf-nq'
  | 'yaf-qu'
  | 'yaf-tc'
  | 'yaf-mp'
  | 'yaf-pr'
  | null;

interface ParamProps {
  utmCampaign: string | null | undefined;
  utmTerm: string | null | undefined;
  community: string | null | undefined;
}

export const marketSegmentFromParams = (paramProps: ParamProps): LandingMarketSegment =>
  match<ParamProps, LandingMarketSegment>(paramProps)
    .with({ community: 'indianmp' }, () => 'indian-meal-plan')
    .with({ community: 'indian' }, () => 'indian-community')
    .with({ community: 'yaf' }, () => 'yaf-dink')
    .with({ community: 'yaf-ff' }, () => 'yaf-ff')
    .with({ community: 'yaf-nq' }, () => 'yaf-nq')
    .with({ community: 'yaf-qu' }, () => 'yaf-qu')
    .with({ community: 'yaf-tc' }, () => 'yaf-tc')
    .with({ community: 'yaf-mp' }, () => 'yaf-mp')
    .with({ community: 'yaf-pr' }, () => 'yaf-pr')
    .with({ community: 'chinese' }, () => 'chinese-community')
    .with({ community: 'halal' }, () => 'halal-community')
    .with(
      {
        utmCampaign: 'PRO_Geo_ZipTargeting_ValuePropTest',
        utmTerm: 'PRO_US_ActiveZips_DietaryPref_DietaryInterest_Registration',
      },
      () => 'dietary-restrictions'
    )
    .with(
      {
        utmCampaign: 'PRO_Geo_ZipTargeting_ValuePropTest',
        utmTerm: 'PRO_US_ActiveZips_Convenience_FamilyYoung_Registration',
      },
      () => 'kid-friendly'
    )
    .with(
      {
        utmCampaign: 'PRO_Geo_ZipTargeting_ValuePropTest',
        utmTerm: 'PRO_US_ActiveZips_Authenticity_1st2ndGen_Registration',
      },
      () => 'authentic-cuisine'
    )
    .with(
      { utmCampaign: 'PRO_Geo_ZipTargeting_ValuePropTest', utmTerm: 'PRO_US_ActiveZips_Control_Broad_Registration' },
      () => 'control'
    )
    .otherwise(() => null);

export const useMarketSegment = () => {
  const marketSegmentStorageKey = `${StorageKeys.HOMEPAGE_CONTEXT}-marketSegment`;
  const [marketSegment, setMarketSegment] = useLocalStorage<LandingMarketSegment>(marketSegmentStorageKey, null);

  return { marketSegment, setMarketSegment };
};
